import {Routes} from "@angular/router";
import {MainLayoutComponent} from "./views/main-layout/main-layout.component";
import {HomepageComponent} from "./views/homepage/homepage/homepage.component";
import {rNames} from "./r.names";
import {Error404Component} from "./views/errors/error404/error404.component";
import {coursesEnabledGuard} from "./guards/courses-enabled.guard";

export const routes: Routes = [

  {
    path: '', component: MainLayoutComponent, children: [
      // homepage
      {path: '', component: HomepageComponent, title: 'Технопортал'},


      {path: 'pdf-viewer', loadComponent: () => import('./views/other/pdf-viewer/pdf-viewer.component').then(m => m.PdfViewerComponent)},

      // курсы валют
      {
        path: rNames.currencies,
        loadChildren: () => import('../currencies/currencies.routes')
          .then(m => m.currenciesRoutes)
      },

      // calcs
      {
        path: rNames.calcs,
        loadChildren: () => import('../calculators/calculatorsRoutes')
          .then(value => value.calculatorRoutes)
      },

      // тарифы и оплата подписки
      {
        path: rNames.pricing,
        loadComponent: () => import('./views/pricing/pricing.component')
          .then(m => m.PricingComponent),
        title: 'Тарифы и подписка'
      },

      // временная страница игры ItFarm
      {path: rNames.gameIt, loadComponent: () => import('./views/game-it/game-it.component').then(m => m.GameItComponent), title: 'ItFarm — игра'},

      // библиотека юзерскриптов
      {path: rNames.userscripts, loadComponent: () => import('./views/userscripts/userscripts.component').then(m => m.UserscriptsComponent), title: 'Юзерскрипты — библиотека userscript\'ов'},
      {path: rNames.donate, loadComponent: () => import('./views/donate/donate.component').then(m => m.DonateComponent), title: 'Поддержать проект'},

      // курсы — включаются тумблером в админке (AppSetting courses.enabled)
      {
        path: rNames.courses,
        canActivate: [coursesEnabledGuard],
        loadChildren: () => import('../courses/courses.routes')
          .then(m => m.coursesRoutes)
      },

      // account
      {
        path: rNames.account,
        loadChildren: () => import('../account/account-routes')
          .then(value => value.accountRoutes)
      },

      // admin
      {
        path: rNames.admin,
        loadChildren: () => import('../admin/adminRoutes')
          .then(value => value.adminRoutes)
      },

      // public users
      {
        path: rNames.users, children: [
          {
            path: ':' + rNames.id, children: [
              {path: '', loadComponent: () => import('./views/users/user-single/user-single.component').then(m => m.UserSingleComponent)},
              {path: rNames.report, loadComponent: () => import('./views/users/user-report/user-report.component').then(m => m.UserReportComponent)}
            ]
          },
        ]
      },

      // auth
      {path: rNames.login, loadComponent: () => import('./views/auth/login/login.component').then(m => m.LoginComponent), title: 'Страница входа на сайт Технопортал'},
      {path: rNames.register, loadComponent: () => import('./views/auth/register/register.component').then(m => m.RegisterComponent), title: 'Страница регистрации на сайте Технопортал'},
      {path: rNames.forgotPassword, loadComponent: () => import('./views/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent), title: 'Восстановление пароля — Смартеп'},
      {path: rNames.resetPassword, loadComponent: () => import('./views/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent), title: 'Новый пароль — Смартеп'},
      {path: rNames.confirmEmail, loadComponent: () => import('./views/auth/confirm-email/confirm-email.component').then(m => m.ConfirmEmailComponent), title: 'Подтверждение email — Смартеп'},
      // #784: приёмник JWT после OAuth-колбэка (Яндекс/VK ID)
      {path: rNames.authExternal, loadComponent: () => import('./views/auth/external/external-auth.component').then(m => m.ExternalAuthComponent), title: 'Вход через соцсеть — Смартеп'},


      // blogs
      {
        path: rNames.blogs, children: [
          {path: '', loadComponent: () => import('./views/news/news-index/news-index.component').then(m => m.NewsIndexComponent), title: 'Новости'},
          {
            path: ':' + rNames.slug,
            loadComponent: () => import('./views/news/news-wrapper/news-wrapper.component').then(m => m.NewsWrapperComponent),
            children: [
              {path: '', loadComponent: () => import('./views/news/news-single/news-single.component').then(m => m.NewsSingleComponent)},
            ]
          },
        ]
      },

      // categories
      {
        path: rNames.catNested, children: [
          {path: '', loadComponent: () => import('./views/categories/categories-index/categories-index.component').then(m => m.CategoriesIndexComponent), title: 'Разделы'},
          {path: ':' + rNames.slug, loadComponent: () => import('./views/categories/category-single/category-single.component').then(m => m.CategorySingleComponent)},
        ]
      },

      // tags
      {
        path: rNames.tags, children: [
          {path: '', loadComponent: () => import('./views/tags/tags-index/tags-index.component').then(m => m.TagsIndexComponent), title: 'Теги'},
          {path: ':' + rNames.slug, loadComponent: () => import('./views/tags/tag-single/tag-single.component').then(m => m.TagSingleComponent)},
        ]
      },

      {path: rNames.error404, component: Error404Component},
      {path: '**', pathMatch: 'full', redirectTo: '/' + rNames.error404}

    ]
  },

];
